window.CollabSeason.ready.then(function(){

(function () {

  var reduce = window.matchMedia(window.CollabSeason.text("sfce63bfb9eba")).matches;
  var member = document.documentElement.classList.contains('member');
  var fine = window.matchMedia(window.CollabSeason.text("s19b4d67507d6")).matches;
  var LOCK = window.CollabSeason.text("scaaad0ebc01b_html");
  var DEALS = window.CollabSeason.deals.filter(function(d){return !d.closed;});
  var TODAY = Date.now();
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function byId(id) { for (var i = 0; i < DEALS.length; i++) if (DEALS[i].id === id) return DEALS[i]; return DEALS[0]; }
  function param(k) { var m = new RegExp('[?&]' + k + '=([^&#]*)').exec(location.search); return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : ''; }
  function when(s) { var time = Date.parse(s || ''); return Number.isFinite(time) ? time : Infinity; }
  function soon(d) { return d.by && when(d.by)>=TODAY && when(d.by)-TODAY<=21*864e5; }
  function title(d) { return member ? esc(d.name) : esc(d.hint).replace(/(\S+)$/, window.CollabSeason.text("s96f75bbb726e_html") + LOCK + '</span>'); }
  function plain(d) { return member ? d.name : d.hint; }
  function applyHref(d) { return d.open; }
  function countUp(el, ms) {
    if (reduce || !el) return;
    var txt = el.getAttribute('data-txt') || el.textContent;
    el.setAttribute('data-txt', txt);
    var m = txt.match(/\d[\d,]*/);
    if (!m) return;
    var n = parseInt(m[0].replace(/,/g, ''), 10), t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / (ms || 800)), e = 1 - Math.pow(1 - k, 3);
      el.textContent = txt.replace(m[0], Math.round(n * e).toLocaleString('en-GB'));
      if (k < 1) requestAnimationFrame(step); else el.textContent = txt;
    }
    requestAnimationFrame(step);
  }
  function rise(el) {
    var w = el.textContent.split(' ');
    el.innerHTML = w.map(function (x, i) { return window.CollabSeason.text("sf6e827661c40_html") + (0.05 + i * 0.06) + 's">' + esc(x) + '</b></span>'; }).join(' ');
  }

  rise(document.getElementById('h1'));

  // Your collabs: the member's applications, newest first, and their saved opportunities
  var dash = document.getElementById('collabs');
  if (member && dash && window.csStore) {
    var showAll = false;
    var appsList = document.getElementById('appsList'), savedList = document.getElementById('savedList'), moreBtn = document.getElementById('appsMore');
    var LABEL = { forward: window.CollabSeason.text("sa48062223f19"), selected: window.CollabSeason.text("s57fd7a0cf33f"), applied: window.CollabSeason.text("sefb5bd92d76a"), opened: window.CollabSeason.text("s1bb19e17dec8"), not: window.CollabSeason.text("s6f3efa36d8ec") };
    function short(s, timestamp) { var locale = document.documentElement.lang === 'en' ? 'en-GB' : document.documentElement.lang; return Number.isFinite(timestamp) ? new Date(timestamp * 1000).toLocaleDateString(locale, {day:'numeric',month:'long'}) : String(s).replace(/,? \d{4}$/, '').replace(/,$/, ''); }
    function find(id) { for (var k = 0; k < DEALS.length; k++) if (DEALS[k].id === id) return DEALS[k]; return null; }
    function nextLine(d, a) {
      if (a.st === 'forward') return window.CollabSeason.text("s235a86b872ae") + short(a.at, a.timestamp) + window.CollabSeason.text("brandsChooseDelay");
      if (a.st === 'selected') return esc(d.name) + window.CollabSeason.text("s55626822949b") + (d.due ? esc(d.due)+'.' : '');
      if (a.st === 'applied') return window.CollabSeason.text("sdcdda403b76d") + esc(d.name) + window.CollabSeason.text("s886b3cc5ef3c");
      if (a.st === 'opened') return window.CollabSeason.text("s35cf7054d51a") + esc(d.name) + window.CollabSeason.text("se232a5e47461") + short(a.at, a.timestamp) + window.CollabSeason.text("didYouSend");
      return esc(d.name) + window.CollabSeason.text("sa0bbc95fe120");
    }
    function row(d, inner) {
      return window.CollabSeason.text("s9511d4c17658_html") + d.url + window.CollabSeason.text("s3b8bd0c194fd") + d.c + window.CollabSeason.text("s0c38c165910a_html") + d.cut + window.CollabSeason.text("sb3b47e424c7d_html") +
        window.CollabSeason.text("s569dc2830a1f_html") + inner + '</div></li>';
    }
    function name(d) { return window.CollabSeason.text("s71ef438a2775_html") + d.url + window.CollabSeason.text("s001ec3e62669_html") + esc(d.name) + window.CollabSeason.text("scba1743396d3_html") + esc(d.pay) + '</p>'; }
    function render() {
      var s = window.csStore.get();
      var apps = s.apps.filter(function (a) { return find(a.id); }).sort(function (x, y) { return y.timestamp - x.timestamp; });
      var saved = s.saved.map(find).filter(Boolean);
      function n(st) { return apps.filter(function (a) { return a.st === st; }).length; }
      document.getElementById('dnF').textContent = n('forward');
      document.getElementById('dnS').textContent = n('selected');
      document.getElementById('dnV').textContent = saved.length;
      document.getElementById('nApps').textContent = apps.length;
      document.getElementById('nSaved').textContent = saved.length;
      appsList.innerHTML = apps.length ? (showAll ? apps : apps.slice(0, 3)).map(function (a) {
        var d = find(a.id);
        return row(d, window.CollabSeason.text("s3f13b1ac58b5_html") + a.st + '">' + LABEL[a.st] + window.CollabSeason.text("sf6b655b88153_html") + short(a.at, a.timestamp) + '</span></p>' + name(d) +
          window.CollabSeason.text("s4730f91a6f4b_html") + nextLine(d, a) + '</p>' +
          (a.st === 'opened' ? window.CollabSeason.text("s181bbc1782df_html") + d.id + window.CollabSeason.text("scd851d141c39_html") + d.open + window.CollabSeason.text("s58aa03140372_html") : '') +
          (a.st === 'selected' ? window.CollabSeason.text("s4b291cf9f03f_html") + d.url + window.CollabSeason.text("sd55bccfa1a97_html") : ''));
      }).join('') : window.CollabSeason.text("s95710124f827_html");
      moreBtn.hidden = apps.length <= 3;
      moreBtn.textContent = showAll ? window.CollabSeason.text("s255beb6510e7") : window.CollabSeason.text("s6134b89407a6") + apps.length;
      savedList.innerHTML = saved.length ? saved.map(function (d) {
        return row(d, window.CollabSeason.text("s022310ee1c2c_html") + esc(d.line) + window.CollabSeason.text("sf6b655b88153_html") + (d.by ? window.CollabSeason.text("s103193d946c4") + short(window.CollabSeason.readerDate(d.by,false)) : '') + '</span></p>' + name(d) +
          window.CollabSeason.text("s46c2763a6fea_html") + applyHref(d) + window.CollabSeason.text("s9c2faf321457_html") + d.id + window.CollabSeason.text("s04f954a5e0ca_html"));
      }).join('') : window.CollabSeason.text("s85d056443c09_html");
    }
    dash.addEventListener('click', async function (e) {
      var m = e.target.closest('[data-mark]'), u = e.target.closest('[data-unsave]');
      try { if (m) { await window.csStore.setApp(m.getAttribute('data-mark'), 'applied'); window.csToast(window.CollabSeason.text("sd732c830518a")); }
      if (u) { await window.csStore.toggle(u.getAttribute('data-unsave')); window.csToast(window.CollabSeason.text("sf81af698dcc6")); } } catch(error) { window.csToast(window.CollabSeason.text('memberUnavailable')); }
    });
    moreBtn.addEventListener('click', function () { showAll = !showAll; render(); });
    var tabs = [document.getElementById('tabApps'), document.getElementById('tabSaved')], panes = [document.getElementById('dashApps'), document.getElementById('dashSaved')];
    function pick(k, focus) {
      tabs.forEach(function (b, j) { b.setAttribute('aria-selected', String(j === k)); b.tabIndex = j === k ? 0 : -1; panes[j].hidden = j !== k; });
      if (focus) tabs[k].focus();
    }
    tabs.forEach(function (b, j) {
      b.addEventListener('click', function () { pick(j); });
      b.addEventListener('keydown', function (e) { if (e.key === window.CollabSeason.text("s8e2f7ffbbdb9") || e.key === window.CollabSeason.text("s48e61e2dd0a2")) { e.preventDefault(); pick(1 - j, true); } });
    });
    document.addEventListener('cs:store', render);
    render();
  }
  window.CollabSeason.fillTiles(DEALS);
  document.querySelectorAll('[data-n]').forEach(function (el, i) { setTimeout(function () { countUp(el, 900); }, 350 + i * 80); });

  // the cards, as on the home page; each opens its own opportunity page through the black wipe
  var grid = document.getElementById('grid');
  DEALS.forEach(function (d) {
    var a = document.createElement('div');
    a.className = 'card'; a.setAttribute('data-id', d.id); a.style.setProperty('--c', d.c);
    a.innerHTML = window.CollabSeason.text("s81824df47def_html") + d.url + window.CollabSeason.text("s2b32b41d3fa0_html") + d.cut + window.CollabSeason.text("s2c639080fe2a_html") +
      '<span class="sticker" data-sticker-kind="'+d.stickerKind+'">'+window.CollabSeasonStickers.html(d)+'</span>' +
      (member ? '' : window.CollabSeason.text("s36da2e34c881_html") + LOCK + window.CollabSeason.text("s5ed19ab7b9e3_html")) + '</div>' +
      window.CollabSeason.text("s6a8268f24df7_html") + esc(d.line) + '</span></div>' +
      window.CollabSeason.text("s570947c194ed_html") + esc(d.line) + window.CollabSeason.text("se5c2c383823a_html") + title(d) + window.CollabSeason.text("s2adcf8381901_html") + esc(d.ask) + '</p>' +
      window.CollabSeason.text("s94643d51ec78_html") + esc(d.pay) + window.CollabSeason.text("sb90886af4d8c_html") + esc(d.pay) + '</span></a>' +
      ((member || window.CollabSeason.canSave) && window.csSaveHTML ? window.csSaveHTML(d.id, member ? d.name : d.hint, !member) : '');
    window.CollabSeason.decorateCardLogo(a,d);
    if(d.newBadge){var badge=document.createElement('span');badge.className='collab-new';badge.textContent=window.CollabSeason.text('newTag');a.querySelector('.panel-wrap').appendChild(badge);}
    a.addEventListener('click', function (e) { if (e.target === a || (a.classList.contains('has-card-logo') && !e.target.closest('a,button'))) window.csGo(d.url); });
    if (fine && !reduce) {
      a.addEventListener('pointermove', function (e) {
        var r = a.getBoundingClientRect();
        a.style.setProperty('--px', (((e.clientX - r.left) / r.width - 0.5) * 22) + 'px');
        a.style.setProperty('--py', (((e.clientY - r.top) / r.height - 0.5) * 12) + 'px');
      });
    }
    grid.appendChild(a);
  });
  var more = null;
  if (!member) {
    more = document.createElement('div');
    more.className = 'more';
    more.innerHTML = window.CollabSeason.text("s8adba73457e2_html")+window.CollabSeason.routes.join+window.CollabSeason.text("s628c8cbc08ba_html");
    grid.appendChild(more);
  }
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));

  // Only overflowing fields need automatic hyphens; ordinary lines stay put.
  var wordFrame = 0;
  function queueCardHyphens() {
    if (wordFrame) return;
    wordFrame = requestAnimationFrame(function () {
      wordFrame = 0;
      var fields = Array.prototype.slice.call(grid.querySelectorAll('.c-line,.c-ask,.c-paid,.c-meta .ln')).filter(function (el) { return el.getClientRects().length; });
      fields.forEach(function (el) { el.classList.remove('cs-hyphenate'); });
      fields.forEach(function (el) { if (el.clientWidth && el.scrollWidth > el.clientWidth + 1) el.classList.add('cs-hyphenate'); });
    });
  }
  document.fonts.ready.then(queueCardHyphens);
  window.addEventListener('resize', queueCardHyphens, { passive: true });
  new MutationObserver(queueCardHyphens).observe(grid, { attributes: true, attributeFilter: ['class'] });

  // filters: one type, one category and one region at a time, plus closing soon; each chip shows how many it would find
  var q2 = document.getElementById('q2'), count = document.getElementById('count'), none = document.getElementById('none'), clear = document.getElementById('clear');
  var sortEl = document.getElementById('sort');
  // item 33: the member filter sidebar (.hf-layout, English members) adds a country (cc), international (intl) and needs-checking (chk) choice
  var hf = !!document.querySelector('.hf-layout');
  function blank() { return { t: 'all', c: null, r: null, s: false, n: false, cc: null, intl: true, chk: false }; }
  var f = blank();
  var pt = param('t'), pc = param('c'), pr = param('r');
  if (['paid', 'gifted', 'affiliate', 'events', 'direct'].indexOf(pt) > -1) f.t = pt;
  if (['fashion', 'beauty', 'skincare', 'lifestyle'].indexOf(pc) > -1) f.c = pc;
  if (['global', 'uk', 'us', 'europe'].indexOf(pr) > -1) f.r = pr;
  if (param('s') === 'soon') f.s = true;
  q2.value = param('q');
  var pcc = param('cc'), pPage = parseInt(param('p'), 10) || 0, pAt = param('at'), pView = param('v');
  if (pView === 'list') grid.classList.add('list');
  if (/^(?:[A-Z]{2}|EU|INTL)$/.test(pcc)) { f.cc = pcc; f.r = null; }
  if (param('intl') === '0') f.intl = false;
  if (param('chk') === '1') f.chk = true;
  if (param('n') === '1') f.n = true;
  if (hf && !f.cc && f.r) { f.cc = { global: 'INTL', uk: 'GB', us: 'US', europe: 'EU' }[f.r]; f.r = null; }
  // country text to codes; unknown is never worldwide (spec section 3, fixture country-table.json)
  var EU = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
  var TOKENS = [[/\b(US|USA|United States|Continental US|48 contiguous US states|US territory)\b/, ['US']], [/\b(UK|United Kingdom|London)\b/, ['GB']], [/\b(EU|Europe|European)\b/, EU], [/\bDACH\b/, ['DE','AT','CH']], [/\bGCC\b/, ['SA','AE','KW','QA','BH','OM']], [/\bNorth America\b/, ['US','CA','MX']], [/\bFrance\b/, ['FR']], [/\bCanada\b/, ['CA']], [/\bAustralia(n)?\b/, ['AU']], [/\bNew Zealand\b/, ['NZ']], [/\bIndia\b/, ['IN']], [/\bBrazil\b/, ['BR']], [/\bColombia\b/, ['CO']], [/\bPeru\b/, ['PE']], [/\bMexico\b/, ['MX']], [/\bSouth Africa\b/, ['ZA']], [/\bAlgeria\b/, ['DZ']], [/\bJapan\b/, ['JP']], [/\bTaiwan\b/, ['TW']], [/\bSaudi Arabia\b/, ['SA']], [/\bUAE\b/, ['AE']], [/\bSouth Korea\b/, ['KR']]];
  function norm(text) {
    var t = String(text || '').trim();
    if (!t) return { cc: [], intl: false, unclear: true, except: [] };
    var intl = /worldwide|international|global|all countries|others considered/i.test(t), outUS = /outside the US/i.test(t);
    var cc = [];
    TOKENS.forEach(function (p) { if (p[0].test(t)) p[1].forEach(function (c) { if (cc.indexOf(c) < 0) cc.push(c); }); });
    if (outUS) { intl = true; cc = []; }
    return { cc: cc, intl: intl, unclear: !cc.length && !intl, except: outUS ? ['US'] : [] };
  }
  window.csNormCountry = norm;
  function place(d, g) {
    var n = d._cn || (d._cn = norm(d.countries));
    if (g.cc === 'INTL') return n.intl || (g.chk && n.unclear);
    var named = g.cc === 'EU' ? n.cc.some(function (x) { return EU.indexOf(x) > -1; }) : n.cc.indexOf(g.cc) > -1;
    if (named) return true;
    if (g.intl && n.intl && n.except.indexOf(g.cc) < 0) return true;
    // a listing whose country is not stated stays in for every country picked; only listings naming other countries drop out (his yes 20 Oct)
    return n.unclear;
  }
  function hay(d) { var logo = !member && window.CollabSeason.logos[d.id]; return [d.hint, d.line, d.ask, d.cat, d.type, d.pay, member ? d.name : logo ? logo.alt : ''].join(' ').toLowerCase(); }
  function ok(d, w, g) { var h = hay(d); return (g.t === 'all' || d.type === g.t) && (!g.c || d.cat === g.c) && (!g.r || d.region === g.r) && (!g.s || soon(d)) && (!g.n || d.isNew) && (!g.cc || place(d, g)) && w.every(function (x) { return h.indexOf(x) > -1; }); }
  function words() { return q2.value.toLowerCase().split(/\s+/).filter(Boolean); }
  function key(d) {
    var s = sortEl.value;
    if (s === 'pay') return -d.val * 10 - (d.type === 'paid' ? 1 : 0);
    if (s === 'close') return when(d.by);
    return -when(d.checked) + DEALS.indexOf(d) / 100;
  }
  var photoPage = 0, pageSize = window.CollabSeason.photoCatalog.hub_page_size;
  var pageNav = document.querySelector('[data-photo-pagination]');
  // item 31, English: Show more adds 12 cards a tap in place of the pages; photoPage then counts the taps, so the address, Back and saved places keep working
  var showMoreNav = document.querySelector('[data-show-more]'), showMoreBtn, showMoreCount;
  if (showMoreNav) {
    pageSize = 12; showMoreBtn = showMoreNav.querySelector('button'); showMoreCount = showMoreNav.querySelector('[data-show-more-count]');
    showMoreBtn.addEventListener('click', function () {
      var from = (photoPage + 1) * pageSize;
      photoPage++; apply(false, true);
      var el = grid.querySelector('.card[data-id="' + last.codes[from] + '"]'), link = el && (el.querySelector('a.c-link, a.cs-opportunity-link') || el.querySelector('a[href]'));
      if (link) link.focus();
    });
  } else {
    pageNav.querySelector('[data-photo-prev]').addEventListener('click', function(){ photoPage--; apply(false,true); goGrid(); });
    pageNav.querySelector('[data-photo-next]').addEventListener('click', function(){ photoPage++; apply(false,true); goGrid(); });
  }
  // Show more keeps every card: each takes the photo of its category used longest ago, so a photo comes back as far down the list as the category allows
  function spreadPhotos(deals) {
    var C = window.CollabSeason, cat = C.photoCatalog, reserved = cat.hub_reserved || [], at = {};
    return deals.map(function (d, i) {
      var pool = cat.card_pools[d.cat], start = -1, best = null, bestAt = Infinity;
      pool.forEach(function (p, k) { if (start < 0 && C.photos[p[1]] === d.cut) start = k; });
      if (start < 0) start = 0;
      for (var k = 0; k < pool.length; k++) {
        var p = pool[(start + k) % pool.length], id = cat.sources[p[1]], seen = id in at ? at[id] : -Infinity;
        if (reserved.indexOf(id) < 0 && seen < bestAt) { best = p; bestAt = seen; }
      }
      if (!best) best = pool[start];
      at[cat.sources[best[1]]] = i;
      return Object.assign({}, d, { img: C.photos[best[0]], cut: C.photos[best[1]], c: 'var(--' + best[2] + ')' });
    });
  }
  function apply(animate, keepPage) {
    if(!keepPage) photoPage=0;
    var w = words();
    var first = cards.map(function (el) { return el.getBoundingClientRect(); });
    var order = cards.slice().sort(function (a, b) { return key(byId(a.getAttribute('data-id'))) - key(byId(b.getAttribute('data-id'))); });
    order.forEach(function (el) { grid.appendChild(el); });
    if (more) grid.appendChild(more);
    var eligible = order.filter(function(el){return ok(byId(el.getAttribute('data-id')),w,f);});
    var pages = Math.max(1,Math.ceil(eligible.length/pageSize));
    photoPage=Math.max(0,Math.min(photoPage,pages-1));
    var pageCards=eligible.slice(showMoreNav ? 0 : photoPage*pageSize,(photoPage+1)*pageSize);
    var pageDeals=pageCards.map(function(el){return byId(el.getAttribute('data-id'));});
    var pagePhotos=showMoreNav ? spreadPhotos(pageDeals) : window.CollabSeason.distinctPhotos(pageDeals,window.CollabSeason.photoCatalog.hub_reserved);
    var assigned = new Map(pagePhotos.map(function(d){return [d.id,d];}));
    if (showMoreNav) { showMoreNav.hidden=pages<=1; showMoreBtn.hidden=photoPage===pages-1; }
    else {
    pageNav.hidden=pages<=1;
    pageNav.querySelector('[data-photo-prev]').disabled=photoPage===0;
    pageNav.querySelector('[data-photo-next]').disabled=photoPage===pages-1;
    pageNav.querySelector('[data-photo-page]').textContent=(photoPage+1)+' / '+pages;
    }
    var shown = 0;
    order.forEach(function (el) {
      var photo=assigned.get(el.getAttribute('data-id')), good=Boolean(photo);
      if(good){el.querySelector('.pop').src=photo.cut;el.style.setProperty('--c',photo.c);}
      el.classList.toggle('gone', !good);
      el.classList.remove('o2', 'o3');
      if (good) { if (shown % 2 === 1) el.classList.add('o2'); if (shown % 3 === 1) el.classList.add('o3'); shown++; }
    });
    window.CollabSeasonStickers.fit(grid);
    var filtered = f.t !== 'all' || f.c || f.r || f.s || f.n || w.length || f.cc || f.chk;
    if (more) more.classList.toggle('gone', !!filtered);
    count.textContent = window.CollabSeason.text("s7282e1fbb2c6") + shown + window.CollabSeason.text("sa4282e4b2298") + eligible.length + window.CollabSeason.text("sb8d38306c4dd");
    if (showMoreNav) showMoreCount.textContent = count.textContent;
    none.hidden = shown > 0;
    clear.hidden = !filtered;
    var anyNew = DEALS.some(function (d) { return d.isNew; });
    document.querySelectorAll('#chips .chip').forEach(function (c) {
      var t2 = c.getAttribute('data-t'), c2 = c.getAttribute('data-c'), r2 = c.getAttribute('data-r'), s2 = c.getAttribute('data-s');
      var on = c.hasAttribute('data-new-filter') ? Boolean(f.n) : t2 ? t2 === f.t : c2 ? c2 === f.c : r2 ? r2 === f.r : f.s;
      c.setAttribute('aria-pressed', String(on));
      var n = c.querySelector('.n');
      if (n) {
        var g = { t: t2 || f.t, c: c2 || f.c, r: r2 || f.r, s: s2 ? true : f.s, n: c.hasAttribute('data-new-filter') ? true : f.n };
        var k = DEALS.filter(function (d) { return ok(d, w, g); }).length;
        n.textContent = k;
        var futureType = t2 === 'events' || t2 === 'direct';
        n.hidden = futureType && k === 0;
        if (futureType && k === 0) c.setAttribute('aria-pressed', 'false');
        c.disabled = k === 0 && (!on || futureType);
      }
      // No collab added in the last 7 days: hide New this week rather than show a greyed 0 (QA 25 Oct item 5).
      if (c.hasAttribute('data-new-filter')) c.style.display = anyNew ? '' : 'none';
    });
    var hfNew = document.getElementById('hfNew');
    if (hfNew && hfNew.closest('label')) hfNew.closest('label').style.display = anyNew ? '' : 'none';
    document.querySelectorAll('[data-tile]').forEach(function (b) {
      var k = b.getAttribute('data-tile');
      b.setAttribute('aria-pressed', String(k === 'soon' ? f.s && f.t === 'all' : f.t === k && !f.s));
    });
    queueCardHyphens();
    last = { shown: shown, total: eligible.length, page: photoPage, pages: pages, codes: eligible.map(function (el) { return el.getAttribute('data-id'); }) };
    // QA round 3 (R3-04): every visitor keeps filters and view in the address, so Back returns to the same results
    writeAddress(); if (hf) document.dispatchEvent(new CustomEvent('cs:hub', { detail: hubState() }));
    if (reduce || animate === false) { cards.forEach(function (el) { if (!el.classList.contains('gone')) el.classList.add('in'); }); return; }
    cards.forEach(function (el, k) {
      if (el.classList.contains('gone')) return;
      var b = el.getBoundingClientRect(), a = first[k];
      el.classList.add('in');
      if (!a.width) { el.animate([{ opacity: 0, transform: 'scale(0.96)' }, { opacity: 1, transform: 'none' }], { duration: 450, easing: 'cubic-bezier(0.2,0.8,0.2,1)' }); return; }
      var dx = a.left - b.left, dy = a.top - b.top;
      if (dx || dy) el.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 600, easing: 'cubic-bezier(0.2,0.8,0.2,1)' });
    });
  }
  var last = { shown: 0, total: 0, page: 0, pages: 1, codes: [] };
  function hubState() { return { t: f.t, c: f.c, s: f.s, n: f.n, cc: f.cc, intl: f.intl, chk: f.chk, q: q2.value, page: last.page, pages: last.pages, shown: last.shown, total: last.total }; }
  function writeAddress() {
    var u = new URLSearchParams();
    if (f.t !== 'all') u.set('t', f.t); if (f.c) u.set('c', f.c); if (f.s) u.set('s', 'soon'); if (f.n) u.set('n', '1');
    if (f.r && !f.cc) u.set('r', f.r); if (f.cc) { u.set('cc', f.cc); if (!f.intl) u.set('intl', '0'); } if (f.chk) u.set('chk', '1'); if (q2.value) u.set('q', q2.value); if (hf && last.page) u.set('p', String(last.page)); if (grid.classList.contains('list')) u.set('v', 'list');
    var qs = u.toString(); history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }
  // the sidebar drives the same filters; goTo opens the page that holds a collab, or reports that it has gone
  window.csHub = {
    state: hubState,
    set: function (partial, page) { Object.keys(partial).forEach(function (k) { if (k === 'q') q2.value = partial.q; else f[k] = partial[k]; }); if (typeof page === 'number') { photoPage = page; apply(false, true); } else apply(); },
    reset: function () { f = blank(); q2.value = ''; },
    goTo: function (code, fallbackPage) {
      var i = last.codes.indexOf(code);
      if (i < 0) { photoPage = fallbackPage || 0; apply(false, true); return false; }
      photoPage = Math.floor(i / pageSize); apply(false, true);
      var el = grid.querySelector('.card[data-id="' + code + '"]'); if (el) el.scrollIntoView({ block: 'center' });
      return true;
    }
  };
  document.querySelectorAll('#chips .chip').forEach(function (c) {
    c.addEventListener('click', function () {
      if (c.disabled) return;
      var t2 = c.getAttribute('data-t'), c2 = c.getAttribute('data-c'), r2 = c.getAttribute('data-r');
      if(c.hasAttribute('data-new-filter')) f.n=!f.n; else if (t2) { f.t = t2; if(t2==='all')f.n=false; } else if (c2) f.c = f.c === c2 ? null : c2; else if (r2) f.r = f.r === r2 ? null : r2; else f.s = !f.s;
      apply();
    });
  });
  function goGrid() { document.getElementById('deals').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
  document.querySelectorAll('[data-tile]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-tile');
      if (k === 'soon') { f = Object.assign(blank(), { s: true }); sortEl.value = 'close'; }
      else { f = Object.assign(blank(), { t: k }); }
      q2.value = ''; apply(false); goGrid();
    });
  });
  clear.addEventListener('click', function () { f = blank(); q2.value = ''; apply(); });
  q2.addEventListener('input', function () { apply(); });
  sortEl.addEventListener('change', function () { apply(); });
  document.getElementById('hubSearch').addEventListener('submit', function (e) { e.preventDefault(); q2.blur(); });
  apply(false);
  if (hf && pAt) window.csHub.goTo(pAt, pPage); else if (hf && pPage) { photoPage = pPage; apply(false, true); }
  cards.forEach(function (el) { el.classList.remove('in'); });

  // grid or list; a list view kept in the address comes back on Back (R3-04)
  if (pView === 'list') { grid.classList.add('list'); document.querySelectorAll('[data-view]').forEach(function (o) { o.setAttribute('aria-pressed', String(o.getAttribute('data-view') === 'list')); }); }
  document.querySelectorAll('[data-view]').forEach(function (b) {
    b.addEventListener('click', function () {
      var list = b.getAttribute('data-view') === 'list';
      if (grid.classList.contains('list') === list) return;
      document.querySelectorAll('[data-view]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
      if (reduce) { grid.classList.toggle('list', list); writeAddress(); return; }
      grid.classList.add('swap');
      setTimeout(function () {
        grid.classList.toggle('list', list);
        grid.classList.remove('swap');
        writeAddress();
        cards.forEach(function (el, k) { if (!el.classList.contains('gone')) el.animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: k * 35, easing: 'cubic-bezier(0.2,0.8,0.2,1)', fill: 'backwards' }); });
      }, 200);
    });
  });

  // cards rise in as they come into view; the join bar shows once the top has gone and steps aside at the end
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (!en.isIntersecting) return; en.target.classList.add('in'); io.unobserve(en.target); });
  }, { threshold: 0.15 });
  cards.forEach(function (c, i) { c.style.setProperty('--d', ((i % 3) * 0.08) + 's'); io.observe(c); });
  if (more) io.observe(more);
  var dock = document.getElementById('dock'), topIn = true, endIn = false;
  function dockState() { if(!dock) return; var on = !member && !topIn && !endIn; dock.classList.toggle('on', on); dock.inert = !on; }
  new IntersectionObserver(function (es) { topIn = es[0].isIntersecting; dockState(); }).observe(document.querySelector('.fresh'));
  var endObs = new IntersectionObserver(function (es) { endIn = es.some(function (e) { return e.isIntersecting; }); dockState(); });
  if(document.getElementById('cta')) endObs.observe(document.getElementById('cta')); endObs.observe(document.querySelector('.foot'));
  var top = document.getElementById('top');
  function onScroll() {
    var y = window.scrollY, max = document.documentElement.scrollHeight - innerHeight;
    top.classList.toggle('line', y > 8);
    top.style.setProperty('--read', max > 0 ? (y / max).toFixed(4) : 0);
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

})();

window.CollabSeason.finishPage();
});

// Keep the focused Hub tile in view when the tile row scrolls sideways (QA 25 Oct item 15).
(function () {
  var fresh = document.querySelector('.fresh');
  if (!fresh) return;
  fresh.addEventListener('focusin', function (e) {
    var tile = e.target.closest('.tile') || e.target;
    if (fresh.contains(tile) && tile.scrollIntoView) tile.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
})();
